export default __webpack_public_path__ + "static/media/react-icon.279e9594.svg";